// import { contact, emptyContact } from "./contact"
import { tag } from "./tag"

export type trainer = {
    _id: string;
    name: string;
    isActive: boolean;
    activityTags: tag[];
    contactList: string[];
    userId: string;
    userEmail: string;
}
export const emptyTrainer = (): trainer => ({
    _id: undefined, // new ObjectID().toHexString(),
    name: '',
    isActive: true,
    activityTags: new Array<tag>(),
    contactList: new Array<string>(),
    userEmail: '',
    userId: '',
});